import {Injectable} from '@angular/core';
import { ICoreDependencies } from "@core/core-boot/core-boot.types";
import {Core} from "@core/core";
import {CoreBase} from "@core/base/core-base";
import {CoreOffice} from "@core/office/core-office";
import {CoreWeb} from "@core/web/core-web";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { ClipboardService } from "@services/clipboard/clipboard.service";
import { CoreEnv, OFFICE_API_WEB_VERSION } from "@core/core-env/core-env";

export const OFFICE_API_VERSION = {
    v1: 1,
    v2: 2,
} as const;

@Injectable({
    providedIn: 'root'
})
export class CoreBoot {
    constructor(
        private http: HttpClient,
        private router: Router,
        private routerInfo: ActivatedRoute,
        private db: NgxIndexedDBService,
        private clipboard: ClipboardService,
        private core: Core,
    ) {}

    public async bootstrap(): Promise<void> {
        const env = await CoreEnv.init();
        const coreNodules = await this.bootstrapCoreModules(env)
        this.core.defineModules(coreNodules, env)
    }

    private async bootstrapCoreModules(coreEnv: CoreEnv): Promise<CoreBase> {
        const env = coreEnv.get();
        const dependencies = this.coreDependencies();

        if (env.office === OFFICE_API_WEB_VERSION) {
            return await CoreWeb.bootstrap(dependencies)
        }

        if (env.office && env.office === OFFICE_API_VERSION.v1) {
            return await CoreOffice.bootstrap(dependencies)
        }

        if (env.office && env.office === OFFICE_API_VERSION.v2) {
            return await CoreOffice.bootstrap(dependencies)
        }

        throw new Error('Implementation for core not found')
    }

    private coreDependencies(): ICoreDependencies {
        return {
            http: this.http,
            router: this.router,
            routerInfo: this.routerInfo,
            db: this.db,
            clipboard: this.clipboard,
        }
    }
}
